<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay" />
    <div class="header-navbar-shadow" />
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h2 class="content-header-title float-start mb-0"> {{ network.id ? 'Edit' : 'New' }} social network<br>
                <div class="mt-1">
                  <div class="form-check form-check-success form-switch d-flex align-items-center">
                    <input
                      id="publishContent"
                      v-model="network.active"
                      type="checkbox"
                      class="form-check-input"
                    >
                    <label
                      class="form-check-label"
                      for="publishContent"
                    ><small class="ms-1">Publish <em
                      id="publishDate"
                      class="ms-2 text-muted"
                    ><small>12/12/2022</small></em></small></label>
                  </div>
                </div>
              </h2>
            </div>
          </div>
        </div>
        <div class="content-header-right text-md-end col-md-3 col-12 d-md-block d-none">
          <div class="mb-1 breadcrumb-right">
            <a
              class="btn btn-icon btn-secondary"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Back to networks list"
              @click="$router.push({ name: 'admin.social-network.index' })"
            ><i data-feather="chevron-left" /></a>
            <a
              href="#"
              class="btn btn-icon btn-flat-secondary"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Senior call settings"
            ><i data-feather="settings" /></a>
          </div>
        </div>
      </div>
      <div class="content-body content-body--senior-call">
        <div class="row">
          <div class="col-12">

            <div class="card">
              <div class="card-header">
                <h3 class="cart-title">
                  <a data-action="collapse">Content</a>
                </h3>
                <div class="heading-elements">
                  <ul class="list-inline mb-0">
                    <li>
                      <a data-action="collapse"><i data-feather="chevron-down" /></a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="card-content collapse show">
                <div class="card-body">
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="mb-1">
                        <label
                          for=""
                          class="form-label"
                        >Name</label>
                        <input
                          v-model="network.name"
                          type="text"
                          class="form-control"
                        >
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="mb-1">
                        <label
                          for=""
                          class="form-label"
                        >URL</label>
                        <input
                          v-model="network.url"
                          type="url"
                          class="form-control"
                        >
                      </div>
                    </div>
                  </div>
                  <hr>
                  <div class="row">
                    <div class="col-sm-3">
                      <label
                        for="formFile"
                        class="form-label"
                      >Icon social network</label>
                      <div>
                        <span
                          v-if="icon_path"
                          v-html="icon_path"
                        />
                        <img
                          v-if="blob_url"
                          height="35px"
                          width="35px"
                          :src="blob_url"
                        >
                        <span
                          class="dis-ib float-end"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Delete social network"
                        ><a
                          href="#"
                          class="btn btn-icon rounded-circle btn-flat-danger"
                          data-bs-toggle="modal"
                          data-bs-target="#modalDeleteWithoutInput"
                        ><i data-feather="trash-2" /></a>
                        </span></div>

                    </div>
                    <div class="col-sm-9">
                      <label
                        for="formFile"
                        class="form-label"
                      >Upload icon</label>
                      <input
                        id="formFile"
                        :ref="`file-icon`"
                        class="form-control"
                        type="file"
                        @change="loadIcon"
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="page-actions">
          <button
            v-if="!sending"
            id="type-success"
            class="btn btn-success"
            @click="save"
          >
            <i data-feather="save" />
            <span class="ms-25 align-middle">Save and Exit</span>
          </button>
          <button
            v-else
            class="btn btn-outline-success"
            type="button"
            disabled=""
          >
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            />
            <span class="ms-25 align-middle">Saving...</span>
          </button>
        </div>

      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  components: {},
  data() {
    return {
      networkId: this.$route.params.id,
      sending: false,
      errors: '',
      icon_path: '',
      blob_url: '',
      file: null,
    }
  },
  computed: {
    ...mapGetters({
      network: 'socialNetworks/network',
    }),
  },
  async mounted() {
    if (this.networkId) {
      await this.$store.dispatch('socialNetworks/fetchNetwork', this.networkId)
      this.icon_path = this.network.icon_url
    } else {
      await this.$store.dispatch('socialNetworks/cleanNetwork')
    }
  },
  methods: {
    async save() {
      this.sending = true

      try {
        if (this.networkId) {
          await this.$store.dispatch('socialNetworks/update', { id: this.networkId, data: this.network, icon: this.file })
        } else {
          await this.$store.dispatch('socialNetworks/create', { data: this.network, icon: this.file })
        }
        this.errors = ''
      } catch (e) {
        this.errors = e.response.data.message
      }

      if (this.errors === '' && this.network.id) {
        Vue.swal('The network has been saved correctly!', '', 'success').then(() => {
          this.$router.push({ name: 'admin.social-network.index' })
        })
      } else {
        // Vue.swal
      }

      this.sending = false
    },
    loadIcon() {
      this.file = this.$refs['file-icon'].files[0]
      this.icon_path = ''
      this.blob_url = URL.createObjectURL(this.file)
    },
  },

}
</script>
